export enum icon {
  MALE_PLACEHOLDER = 'https://smartaccupay-data.s3.us-central-1.ionoscloud.com/male-placeholder.png',
  FEMALE_PLACEHOLDER = 'https://smartaccupay-data.s3.us-central-1.ionoscloud.com/female-placeholder.png',
  INVOICE_LOGO = './assets/images/smartaccupay.png',
  QUICKBOOKS_GREY = './assets/images/icons/grey-quickbooks.svg',
  QUICKBOOKS_GREEN = './assets/images/icons/quickbooks.svg',
  QUICKBOOKS_ONLINE_LOGO = './assets/images/qb_online.png',
  QUICKBOOKS_DESKTOP_LOGO = './assets/images/qb_desktop.png',
  MAIL_ICON = './assets/images/icons/mail.png',
  MESSAGE_ICON = './assets/images/icons/message.png',
  CONTECT_INFO = './assets/images/icons/contact-info.png',
  DOCUMENT = './assets/images/icons/document.png',
  EMERGENCY_CONTECT = './assets/images/icons/emergency-contect.png',
  EMP_INFO = './assets/images/icons/emp-info.png',
  PERSONAL_INFO = './assets/images/icons/personal-info.png',
  LOGO_PLACEHOLDER = './assets/images/placeholder_logo.png',
  SMARTACCUPAY_GIF = './assets/images/smartaccupay-gif.gif',
}
